/*global myModal, logger, myDataLayer, analyticEventTracker, disableCheckPriceChanges, pp, ApplePaySession, creditCard, google, braintree, inputDirectionChange */
var paymentCommon = {
    paymentType: 'cc',
    GATEWAY_ID_LPB: 1,
    GATEWAY_ID_BRAINTREE: 4,
    GATEWAY_ID_STRIPE: 6,
    GATEWAY_ID_CHECKOUT: 7,
    GATEWAY_ID_CHECKOUT_NAS: 8,
    GATEWAY_ID_CHECKOUT_UAE: 9,
    GATEWAY_ID_MAGNETIQ: 11,
    transactionOrderId: null,
    countryCode: $('#billingCountry').val(),
    isModification: _d.isModification,
    domElements: {
        number: $('#reservationNumber'),
        email: $('#email')
    },
    init: function() {
        paymentMethods.init();

        $('body').on('click', '.proceed-payment', function(e) {
            e.preventDefault();
            paymentCommon.paymentProcess($(this));
        }).on('click', '.cancelModificationButton', function(e) {
            e.preventDefault();
            myModal.openStaticModal('modifyCancel', {noHeader: true});
        });

        $('.payments-methods-option').on('click', function() {
            const that = $(this);
            if (that.hasClass('active')) {
                return;
            }

            $('.payments-methods-option').removeClass('active');
            that.addClass('active');
        });

        this.cardFormValidationCommon();
        this.avs();

        logger.setReservationNumber(paymentCommon.domElements.number.val());
        logger.setEventGroup('Payment page');

        window.addEventListener('message', function(event) {
            try {
                if (event &&
                    event.origin.indexOf('applepay') > -1 &&
                    Object.prototype.hasOwnProperty.call(event.data, 'messageType') &&
                    event.data.messageType === 'windowclosing') {
                    paymentCommon.formState('enable');
                }
            } catch (e) {
                paymentCommon.formState('enable');
            }
        }, false);

        inputDirectionChange.onChangeAction('input');
    },
    create3DsecureForm: function(formParams) {
        let html = '';

        $('#d3d_form').empty();
        $('#d3d_form').prop('action', formParams.url);

        for (const fieldName in formParams.fields) {
            if (Object.prototype.hasOwnProperty.call(formParams.fields, fieldName)) {
                html += '<input type="text" name="' + fieldName + '" value="' + formParams.fields[fieldName] + '" />';
            }
        }

        $('#d3d_form').html(html);
        $('#d3d_form').submit();
    },
    callBackBrainTree: function(params) {

        var callBackUrl = _d.url.payments.callBack.replace('number', params.reservationNumber)
            .replace('transactionOrderId', params.transactionOrderId)
            .replace('email', btoa(params.email));

        $.postJSON(callBackUrl, params, function(response) {
            if (!response.error) {
                myDataLayer.send('payment', {'paymentMethod': $('#ccTypeName').val()});

                window.location = _d.url.reservation.confirmation
                    .replace('number', response.data.reservation_number)
                    .replace('email', btoa(response.data.driver_email));

            } else {
                if (response.error === 2) {
                    window.location = _d.url.reservation.show
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));

                }

                logger.setEventName('Error on Braintree callback');
                logger.setEventResult(false);
                logger.setEventDescription('Error on Braintree callback: ' + response.message);
                logger.logEvent();

                paymentCommon.formState('enable', {'error': response.message});
            }
        });
    },
    paymentProcess: function(paymentBtn) {
        const isCard = paymentBtn.hasClass('is-card');
        const isGooglePay = paymentBtn.hasClass('is-google-pay');
        const isSofort = paymentBtn.hasClass('is-sofort');
        const isApplePay = paymentBtn.hasClass('is-apple-pay');
        const isFPOA = paymentBtn.hasClass('is-fpoa');
        let paymentFormName;

        paymentFormName = paymentBtn.closest('form').attr('data-form-name');

        let requestForm = paymentBtn.closest('form');
        const requestData = requestForm.serialize() + '&ga_host=' + encodeURI(document.location.hostname);

        paymentCommon.sendPayNowTapEvent(paymentBtn);

        if (paymentCommon.cardFormHasErrors(requestForm)) {

            logger.setEventName(paymentFormName + ' form validation error');
            logger.setEventResult(false);
            logger.setEventDescription('User tried to submit a ' + paymentFormName + ' form with invalid credentials');
            logger.logEvent();

            let paymentErrorLogPostData = paymentCommon.getPaymentErrorLogPostData(requestForm, paymentFormName);
            analyticEventTracker.trackEvent(paymentErrorLogPostData);

            paymentCommon.formState('enable');

            const firstError = $('.payment-form:visible').find('.error:first');
            paymentCommon.addPaymentErrors();
            if (firstError.length) {
                $('html,body').stop().animate({
                    scrollTop: firstError.offset().top - 16
                }, 400);
            }

            return false;

        } else {
            paymentCommon.formState('disable', {'fpoa': isFPOA});

            if (isApplePay) {
                logger.setEventName(paymentFormName + ' form submit');
                logger.setEventResult(true);
                logger.setEventDescription('User has successfully submitted ' + paymentFormName + ' form. Front-end validation passed.');
                logger.logEvent();

                paymentCommon.applePay();
            } else if (typeof disableCheckPriceChanges !== 'undefined' && disableCheckPriceChanges) {
                logger.setEventName(paymentFormName + ' form submit');
                logger.setEventResult(true);
                logger.setEventDescription('User has successfully submitted ' + paymentFormName + ' form. Front-end validation passed.');
                logger.logEvent();

                if (isCard) {
                    paymentCommon.cc(requestData);
                } else if (isGooglePay) {
                    paymentCommon.googlePay();
                } else if (isSofort) {
                    paymentCommon.alternate(requestData);
                } else if (isFPOA) {
                    paymentCommon.fpoa(requestData);
                } else {
                    paymentCommon.paypal(requestForm);
                }
            } else {
                pp.checkPriceChanges()
                    .then(function(result) {

                        if (typeof result === 'boolean' && result) {
                            logger.setEventName(paymentFormName + ' form submit with Price check');
                            logger.setEventResult(true);
                            logger.setEventDescription('User has successfully submitted ' + paymentFormName + ' form. Front-end validation passed. Checked for price change.');
                            logger.logEvent();

                            if (isCard) {
                                paymentCommon.cc(requestData);
                            } else if (isGooglePay) {
                                paymentCommon.googlePay();
                            } else if (isSofort) {
                                paymentCommon.alternate(requestData);
                            } else if (isFPOA) {
                                paymentCommon.fpoa(requestData);
                            } else {
                                paymentCommon.paypal(requestForm);
                            }
                        } else {
                            let formStateOpts = { preventModalClose: true };
                            paymentCommon.formState('enable', formStateOpts);
                        }
                    })
                    .catch(function() {
                        logger.setEventName(paymentFormName + ' form submit with Price check');
                        logger.setEventResult(false);
                        logger.setEventDescription(paymentFormName + ': problem with checkPriceChanges (catch).');
                        logger.logEvent();
                        paymentCommon.formState('enable');
                        _d.jsWarning('Problem with checkPriceChanges (catch)');
                    });
            }

            return false;

        }
    },
    sendCcData: function(requestData) {
        var _this = this;

        $.post(_d.url.payments.payByCc, requestData, function(response) {
            if (!response.error) {
                if (response.required3dSecure !== 'undefined' && response.required3dSecure) {
                    logger.setEventName('3DSecure');

                    switch (response.paymentGatewayId) {
                        case paymentCommon.GATEWAY_ID_LPB:
                        case paymentCommon.GATEWAY_ID_MAGNETIQ:
                            logger.setEventResult(true);
                            logger.setEventDescription('3DSecure window has shown (LPB)');
                            logger.logEvent();

                            _this.create3DsecureForm(response.paramsFor3dSecureChallenge.form);
                            break;
                        case paymentCommon.GATEWAY_ID_STRIPE:
                        case paymentCommon.GATEWAY_ID_CHECKOUT:
                        case paymentCommon.GATEWAY_ID_CHECKOUT_NAS:
                        case paymentCommon.GATEWAY_ID_CHECKOUT_UAE:
                            window.location = response.paramsFor3dSecureChallenge.url;
                            break;
                        case paymentCommon.GATEWAY_ID_BRAINTREE:
                        default:
                            logger.setEventResult(true);
                            logger.setEventDescription('3DSecure window has shown (Braintree)');
                            logger.setTransactionOrderId(response.transactionOrderId);
                            logger.logEvent();

                            BrainTreeObj.createFields();
                            BrainTreeObj.setupComponents(response.paramsFor3dSecureChallenge.token).then(function(instances) {
                                BrainTreeObj.hf = instances[0];
                                BrainTreeObj.threeDS = instances[1];

                                BrainTreeObj.pay(response.paramsFor3dSecureChallenge.clientData);
                            }).catch(function() {
                                logger.setEventResult(false);
                                logger.setEventDescription('Error on BrainTreeObj.setupComponents. Error: ' + _d.t.paymentProblem);
                                logger.logEvent();

                                _d.jsWarning('Error on BrainTreeObj.setupComponents');
                                paymentCommon.formState('enable', {'error': _d.t.paymentProblem});
                            });
                            break;

                    }
                } else {
                    logger.setEventName('Payment successfully finished');
                    logger.setEventResult(true);
                    logger.setEventDescription('Payment successfully finished without 3DSecure challenge');
                    logger.logEvent();

                    myDataLayer.send('payment', {'paymentMethod': $('#ccTypeName').val()});

                    window.location = _d.url.reservation.confirmation
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));
                }

            } else {
                logger.setEventName('Error on Hold (Credit Card)');
                logger.setEventResult(false);
                logger.setEventDescription('Error: ' + response.error + ', Message: ' + response.message);
                logger.logEvent();

                if (response.error === 2) {
                    window.location = _d.url.reservation.show
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));

                }

                paymentCommon.formState('enable', {'error': response.message});
            }
        }, 'json').fail(function() {
            paymentCommon.formState('enable', {'error': _d.t.paymentProblem});
        });
    },
    sendAlternate: function(requestData) {
        $.postJSON(_d.url.payments.payBySofort, requestData, function(response) {
            //console.log(response);
            if (!response.error) {
                window.location = response.paramsFor3dSecureChallenge.url;
            } else {
                logger.setEventName('Error on Hold (Sofort)');
                logger.setEventResult(false);
                logger.setEventDescription('Error: ' + response.error + ', Message: ' + response.message);
                logger.logEvent();

                if (response.error === 2) {
                    window.location = _d.url.reservation.show
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));

                }
                paymentCommon.formState('enable', {'error': response.message});
            }
        });
    },
    alternate: function(requestData) {
        try {
            dataLayer.push({
                'payment_start_data': {
                    'category': 'PaymentStart',
                    'action': 'paynow',
                    'label': 'Alternate',
                    'value': ''
                },
                'event': 'payment_start'
            });
        } catch (err) {}

        paymentCommon.sendAlternate(requestData);
    },
    cc: function(requestData) {

        try {
            dataLayer.push({
                'payment_start_data': {
                    'category': 'PaymentStart',
                    'action': 'paynow',
                    'label': 'CreditCard',
                    'value': ''
                },
                'event': 'payment_start'
            });
        } catch (err) {}

        if ($('#payWithBookingCredit').length > 0) {
            $.postJSON(_d.url.payments.payByBC, requestData, function(response) {
                if (!response.error) {
                    //myDataLayer.send('payment', {'paymentMethod': $('#ccTypeName').val()});
                    logger.setEventName('Payed with Booking credit');
                    logger.setEventResult(true);
                    logger.setEventDescription('User has successfully payed with his booking credits');
                    logger.logEvent();

                    window.location = _d.url.reservation.confirmation
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));
                } else {
                    logger.setEventName('Error with Booking credit payment');
                    logger.setEventAdditionalData(response.data.reservation_number + ' ' + response.data.driver_email);
                    logger.setEventResult(false);
                    logger.setEventDescription('Error code: ' + response.error + ', Error message: ' + response.message);
                    logger.logEvent();

                    if (response.error === 2) {
                        window.location = _d.url.reservation.show
                            .replace('number', response.data.reservation_number)
                            .replace('email', btoa(response.data.driver_email));
                    }

                    paymentCommon.formState('enable', {'error': response.message});
                }
            });
        } else {
            paymentCommon.sendCcData(requestData);
        }
    },
    applePay: function() {
        logger.setEventName('Apple Pay');

        try {
            dataLayer.push({
                'payment_start_data': {
                    'category': 'PaymentStart',
                    'action': 'paynow',
                    'label': 'Apple Pay',
                    'value': ''
                },
                'event': 'payment_start'
            });

        } catch (err) {
        }

        var paymentDataRequest = BraintreeSDK.applePayInstance.createPaymentRequest({
            total: {
                label: _d.t.paymentItemLine.replace('{{number}}', paymentCommon.domElements.number.val()),
                amount: BraintreeSDK.applePayButton.data('amount').toString()
            },
            currencyCode: BraintreeSDK.applePayButton.data('currency')
        });

        var session = new ApplePaySession(3, paymentDataRequest);

        paymentMethods.register('apple-pay').then((result) => {
            if (result && Object.prototype.hasOwnProperty.call(result, 'data') && Object.prototype.hasOwnProperty.call(result.data, 'gateway')) {
                paymentCommon.processApplePay(result.data.gateway.toLowerCase(), session);
            } else {
                paymentCommon.processApplePay('braintree', session);
            }
        });
    },
    processApplePay: function(gateway, session) {
        session.begin();
        if (gateway === 'braintree') {
            session.onvalidatemerchant = function(event) {
                BraintreeSDK.applePayInstance.performValidation({
                    validationURL: event.validationURL,
                    displayName: 'Discover Cars'
                }, function(err, merchantSession) {
                    if (err) {
                        logger.setEventResult(false);
                        logger.setEventDescription('Apple Pay failed to load: ' + JSON.stringify(err));
                        logger.logEvent();

                        paymentMethods.log('braintree', 'apple-pay', 'Apple Pay failed to load', err);
                        return;
                    } else {
                        logger.setEventResult(true);
                        logger.setEventDescription('Apple Pay window loaded');
                        logger.logEvent();
                    }
                    session.completeMerchantValidation(merchantSession);
                });
            };
            session.onpaymentauthorized = function(event) {
                BraintreeSDK.applePayInstance.tokenize({
                    token: event.payment.token
                }, function(tokenizeErr, result) {
                    if (tokenizeErr) {
                        logger.setEventResult(false);
                        logger.setEventDescription('Error tokenizing Apple Pay: ' + JSON.stringify(tokenizeErr));
                        logger.logEvent();

                        paymentMethods.log('braintree', 'apple-pay', 'Error tokenizing Apple Pay', tokenizeErr);
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                        return;
                    }

                    // TODO append result data
                    if (Object.prototype.hasOwnProperty.call(BraintreeSDK, 'deviceData')) {
                        result.deviceData = BraintreeSDK.deviceData;
                    }

                    result.source = 'new';
                    result.reservationNumber = paymentCommon.domElements.number.val();
                    result.email = paymentCommon.domElements.email.val();
                    result.amount = parseFloat(BraintreeSDK.applePayButton.data('amount'));
                    result.transactionOrderId = paymentCommon.transactionOrderId;

                    paymentMethods.hold('apple-pay', result);

                    logger.setEventResult(true);
                    logger.setEventDescription('Success transaction');
                    logger.logEvent();

                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                });
            };
        } else {
            session.onvalidatemerchant = function(event) {
                $.postJSON(_d.url.payments.validateAP, {url: event.validationURL, merchant: gateway}, function(response) {
                    if (Object.prototype.hasOwnProperty.call(response, 'content')) {
                        let merchantSession = JSON.parse(response.content);
                        session.completeMerchantValidation(merchantSession);
                    } else {
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                    }
                });
            };
            session.onpaymentauthorized = function(event) {
                if (event) {
                    let result = {};
                    if (Object.prototype.hasOwnProperty.call(BraintreeSDK, 'deviceData')) {
                        result.deviceData = BraintreeSDK.deviceData;
                    }
                    result.source = 'new';
                    result.reservationNumber = paymentCommon.domElements.number.val();
                    result.email = paymentCommon.domElements.email.val();
                    result.amount = parseFloat(BraintreeSDK.applePayButton.data('amount'));
                    result.nonce = event.payment.token;
                    result.transactionOrderId = paymentCommon.transactionOrderId;

                    paymentMethods.hold('apple-pay', result);

                    logger.setEventResult(true);
                    logger.setEventDescription('Success transaction');
                    logger.logEvent();

                    session.completePayment(ApplePaySession.STATUS_SUCCESS);
                } else {
                    session.completePayment(ApplePaySession.STATUS_FAILURE);
                }
            };
        }

        session.oncancel = function(err) {
            if (!err) {
                return;
            }
            var error = {
                'statusCode': err.type || 'unknown',
                'sessionError': err.sessionError || 'No additional details'
            };

            paymentCommon.formState('enable');

            logger.setEventResult(true);
            logger.setEventDescription('Apple Pay window closed');
            logger.logEvent();

            paymentMethods.log('braintree', 'apple-pay', 'Payment UI is dismissed', error);
        };
    },
    fpoa: function(requestData) {

        $.postJSON(_d.url.payments.fpoa, requestData, function(response) {
            logger.setEventName('FPOA');

            if (!response.error) {
                logger.setEventResult(true);
                logger.setEventDescription('Success FPOA');
                logger.logEvent();

                //myDataLayer.send('payment', {'paymentMethod': $('#ccTypeName').val()});
                window.location = _d.url.reservation.confirmation
                    .replace('number', response.data.reservation_number)
                    .replace('email', btoa(response.data.driver_email));
            } else {
                logger.setEventResult(false);
                logger.setEventDescription('FPOA error: ' + response.message);
                logger.logEvent();

                paymentCommon.formState('enable', {'error': response.message});
            }
        });

    },
    paypal: function(paypalForm) {

        myDataLayer.send('payment', {'paymentMethod': 'Paypal'});

        try {
            dataLayer.push({
                'payment_start_data': {
                    'category': 'PaymentStart',
                    'action': 'paynow',
                    'label': 'PayPal',
                    'value': ''
                },
                'event': 'payment_start'
            });
        } catch (err) {
        }

        logger.setEventName('Redirect to Paypal payment page');
        logger.setEventResult(true);
        logger.setEventDescription('User successfully submitted the form and system redirect to Paypal payment page');
        logger.logEvent();

        paypalForm.submit();

        return true;
    },
    formState: function(mode, options) {

        const paymentBtn = $('.proceed-payment:visible');
        const errorMsg = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'error') ? options.error : false);
        const paymentTypeHandler = $('.payment-type');
        const preventModalClose = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'preventModalClose') ? options.preventModalClose : false);

        if (mode === 'disable') {
            paymentBtn.attr('disabled', 'disabled');
            paymentTypeHandler.addClass('disabled');

            let modalLayout = (typeof options !== 'undefined' && Object.prototype.hasOwnProperty.call(options, 'fpoa') && options.fpoa ? 'processingPaymentFPOAModal' : 'processingPaymentModal');
            if (!_d.isMobile) {
                paymentCommon.removePaymentErrors('all', true);
            }
            myModal.openStaticModal(modalLayout, {modalWindowClass: 'w-360', noHeader: true, noCloseButtonInHeader: true});

        } else {

            paymentTypeHandler.removeClass('disabled');
            if (!preventModalClose) {
                if (_d.isMobile) {
                    myModal.forceClose();
                } else {
                    myModal.close(0);
                }
            }

            if (errorMsg !== false) {
                paymentCommon.addPaymentErrors(errorMsg);
                const errorBlock = $('.payment-form:visible');
                $('html,body').animate({
                    scrollTop: errorBlock.offset().top - 60
                }, 400);
            }

            paymentBtn.removeAttr('disabled').removeClass('loading').blur();
        }
    },
    formContentPlaceholder: function(show) {
        const preloadSkeleton = $('.payments-methods-preload-skeleton');
        const hiddenPaymentMethods = $('.payments-methods-hidden');
        if (show) {
            preloadSkeleton.show();
            hiddenPaymentMethods.addClass('hidden');
        } else {
            preloadSkeleton.hide();
            hiddenPaymentMethods.removeClass('hidden');
        }
    },
    cardFormHasErrors: function(form) {
        $(form).find('.select-field, .validate-input').each(function() {
            $(this).trigger('change');
        });

        return $(form).find('.validate-input, .select-box').hasClass('error');
    },
    addPaymentErrors: function(errorMsg = '') {
        const paymentForm = $('.payment-form:visible');
        const errorList = [];

        if (errorMsg !== '') {
            paymentForm.find('.payment-error').html(errorMsg);
            paymentForm.find('.payment-error-block').removeClass('dc-ui hidden');
            paymentForm.find('.payment-error-blocks').removeClass('dc-ui hidden');
            return;
        }

        paymentForm.find('.form-row .error-message div:visible').each(function() {
            errorList.push($(this).text());
        });

        if (errorList.length > 0) {
            const listItems = errorList.map(item => `<li>${item}</li>`).join('');
            paymentForm.find('.payment-error-list').html(`<ul class="dc-ui list no-padding-y">${listItems}</ul>`);
            paymentForm.find('.payment-error-list-block').removeClass('dc-ui hidden');
            paymentForm.find('.payment-error-blocks').removeClass('dc-ui hidden');
            return;
        }

        paymentCommon.removePaymentErrors('errorList');
    },
    removePaymentErrors(type, forced = false) {
        const paymentForm = $('.payment-form:visible');
        if (type === 'errorBlock') {
            paymentForm.find('.payment-error-block').addClass('dc-ui hidden');
        } else {
            paymentForm.find('.payment-error-list-block').addClass('dc-ui hidden');
        }

        if (paymentForm.find('.payment-error-block').hasClass('dc-ui hidden') && paymentForm.find('.payment-error-list-block').hasClass('dc-ui hidden')) {
            paymentForm.find('.payment-error-blocks').addClass('dc-ui hidden');
        }
        if (forced) {
            paymentForm.find('.payment-error-blocks').addClass('dc-ui hidden');
        }
    },
    addError: function(element, options) {
        var elementHandler = $('#' + element),
            errorHandler = $('#' + element + '_error');

        elementHandler.removeClass('success').addClass('error');

        if ($.isEmptyObject(options)) {
            errorHandler.addClass('show').removeClass('hidden');
        } else {
            elementHandler.parent().removeClass('success').addClass('error');
            $('#' + options.errId + '_error').addClass('show').removeClass('hidden');
        }

        myDataLayer.send('payment-error', {'fieldName': elementHandler[0].name});
        elementHandler.parents('.form-row').addClass('error-field');
    },
    removeError: function(element, options) {
        const elementHandler = $('#' + element);
        const errorHandler = $('#' + element + '_error');
        const showSuccess = !Object.hasOwn(options, 'disableSuccess');

        elementHandler.removeClass('error');
        if (showSuccess) {
            elementHandler.addClass('success');
        }

        if (!Object.hasOwn(options, 'errId')) {
            errorHandler.removeClass('show').addClass('hidden');
        } else {
            elementHandler.parent().removeClass('error');
            if (showSuccess) {
                elementHandler.parent().addClass('success');
            }
            $('#' + options.errId + '_error').removeClass('show').addClass('hidden');
        }
        errorHandler.parents('.form-row').removeClass('error-field');
    },
    cardFormValidationDesktop: function() {
        paymentCommon.cardFormValidationCommon(function(that) {
            if (that.attr('name') === 'billingState') {
                that = that.next();

                if (!that.is(':visible')) {
                    return false;
                }
            }
        });
    },
    cardFormValidationMobile: function() {
        paymentCommon.cardFormValidationCommon();
    },
    cardFormValidationCommon: function(additionalChecks) {
        $('.payment-form .select-field').on('blur change', function(e) {
            var that = $(this),
                ccMonth = $('#ccExpMonth'),
                ccYear = $('#ccExpYear');

            if (e.type === 'blur' && that.prop('id') === 'ccExpYear' && parseInt(ccMonth.val()) === 0) {
                paymentCommon.addError(that.prop('id'), {'errId': that.data('id')});
            } else if (ccMonth.val() > 0 && ccYear.val() > 0) {
                paymentCommon.removeError('ccExpMonth', {'errId': ccMonth.data('id')});
                paymentCommon.removeError('ccExpYear', {'errId': ccYear.data('id')});
            } else if (that.prop('id') === 'ccExpMonth' && parseInt(that.val()) === 0) {
                paymentCommon.addError(that.prop('id'), {'errId': ccMonth.data('id')});
            } else if (that.prop('id') === 'ccExpYear' && parseInt(that.val()) === 0) {
                paymentCommon.addError(that.prop('id'), {'errId': ccYear.data('id')});
            }

            paymentCommon.addPaymentErrors();
        });

        $('.payment-form .validate-input').on('blur keypress change input', function(e) {
            let that = $(this);
            let options = {};
            let errorField = that.prop('id');
            let value = that.val().trim();
            let isError = false;

            if (!value) {
                isError = true;
            }

            // Find the parent form of the active payment method
            const activeForm = that.closest('.payment-form');

            const tosAgree = activeForm.find('[name="tos_agree"]');
            const tosAgreeConditions = activeForm.find('[name="tos_agree_conditions"]');

            switch (that.attr('name')) {
                case 'ccName':
                    if (!value.match(/^[a-zA-Z-.' ]*$/)) {
                        isError = true;
                    }
                    break;
                case 'ccNumber':
                    let cardNumber = $('.input-card-number').val();
                    cardNumber = (String(cardNumber)).replace(/\D/g, '');
                    const card = creditCard.cardFromNumber(cardNumber);

                    if (cardNumber.length > 0) {
                        paymentCommon.removeError(errorField, {});
                        const isValidCard = creditCard.validateCardNumber(cardNumber, e.type);

                        if (['blur', 'change'].indexOf(e.type) >= 0 && cardNumber.length >= card.length[0]) {
                            isError = !isValidCard;
                            options = {'errId': that.data('invalid')};
                        } else if (isValidCard) {
                            isError = false;
                            options = {'errId': that.data('invalid')};
                        }
                    } else {
                        isError = true;
                        paymentCommon.removeError(errorField, {'errId': that.data('invalid')});
                    }
                    break;
                case 'ccCCV':
                    if (e.type === 'blur') {
                        if (!value.match(/^[0-9]{3,4}$/)) {
                            isError = true;
                        }
                    } else if (!value.match(/^\d+$/)) {
                        isError = true;
                    }
                    break;
                case 'tos_agree':
                case 'tos_agree_conditions':
                    if (tosAgree.length && tosAgreeConditions.length) {
                        if (!tosAgree.is(':checked') || !tosAgreeConditions.is(':checked')) {
                            isError = true;
                        }
                    } else if (!that.is(':checked')) {
                        isError = true;
                    }
                    break;
                case 'billingState':
                    if (value === '0') {
                        isError = true;
                    }
                    break;
                case 'billingAddressLine1':
                case 'billingCity':
                    if (value.length === 0) {
                        isError = true;
                    }
                    break;
                case 'billingPostalCode':
                    if (value.length === 0) {
                        paymentCommon.removeError(errorField, {'errId': that.data('invalid')});
                        isError = true;
                    } else if (['US', 'CA'].indexOf(paymentCommon.countryCode) >= 0 && ['blur', 'change'].indexOf(e.type) >= 0) {
                        paymentCommon.removeError(errorField, options);
                        if (!value.match(/^(\d{5}(-\d{4})?|^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$)$/)) {
                            isError = true;
                            options = {'errId': that.data('invalid')};
                        } else {
                            isError = false;
                            options = {'errId': that.data('invalid')};
                        }
                    }
                    break;
                default:
                    isError = false;
                    break;
            }

            if (additionalChecks) {
                additionalChecks(that);
            }

            if (isError) {
                paymentCommon.addError(errorField, options);
            } else {
                paymentCommon.removeError(errorField, options);
            }

            paymentCommon.addPaymentErrors();
        });
    },
    googlePay: function() {

        logger.setEventName('Google Pay');

        try {
            dataLayer.push({
                'payment_start_data': {
                    'category': 'PaymentStart',
                    'action': 'paynow',
                    'label': 'Google Pay',
                    'value': ''
                },
                'event': 'payment_start'
            });
        } catch (err) {
        }

        var paymentDataRequest = BraintreeSDK.googlePayInstance.createPaymentDataRequest({
            transactionInfo: {
                currencyCode: BraintreeSDK.googlePayButton.data('currency'),
                totalPriceStatus: 'FINAL',
                totalPrice: BraintreeSDK.googlePayButton.data('amount').toString() // Your amount
            }
        });

        paymentMethods.register('google-pay').then(function(result) {
            let client;
            if (result && Object.prototype.hasOwnProperty.call(result, 'data') && Object.prototype.hasOwnProperty.call(result.data, 'gateway')) {
                client = paymentCommon.getUnifiedGooglePayClient(result.data.environment, result.data.gateway_name, result.data.gateway_merchant_id, result.data.google_merchant_id, paymentDataRequest);
                paymentCommon.processGooglePay(client, result.data.gateway.toLowerCase(), paymentDataRequest);
            } else {
                client = paymentCommon.getBraintreeGooglePayClient(paymentDataRequest);
                paymentCommon.processGooglePay(client, 'braintree', paymentDataRequest);
            }
        });

        return true;
    },
    processGooglePay: function(client, gateway, paymentDataRequest) {

        client.loadPaymentData(paymentDataRequest).then(function(paymentData) {
            logger.setEventResult(true);
            logger.setEventDescription('Google Pay window loaded');
            logger.logEvent();

            if (gateway === 'braintree' && !Object.prototype.hasOwnProperty.call(client, 'parseResponse')) {
                client = BraintreeSDK.googlePayInstance;
            }

            client.parseResponse(paymentData, function(err, result) {
                if (err) {
                    logger.setEventResult(false);
                    logger.setEventDescription('Error parsing Google Pay response: ' + JSON.stringify(err));
                    logger.logEvent();

                    paymentCommon.formState('enable', {'error': _d.t.paymentProblem});
                    paymentMethods.log(gateway, 'google-pay', 'Error parsing Google Pay response', err);
                }

                if (Object.prototype.hasOwnProperty.call(BraintreeSDK, 'deviceData')) {
                    result.deviceData = BraintreeSDK.deviceData;
                }
                result.source = 'new';
                result.reservationNumber = paymentCommon.domElements.number.val();
                result.email = paymentCommon.domElements.email.val();
                result.amount = parseFloat(BraintreeSDK.googlePayButton.data('amount'));
                result.transactionOrderId = paymentCommon.transactionOrderId;

                logger.setEventResult(true);
                logger.setEventDescription('Success transaction');
                logger.logEvent();

                paymentMethods.hold('google-pay', result);
            }).catch(function(err) {
                logger.setEventResult(false);
                logger.setEventDescription('Error parsing Google Pay response (catch): ' + JSON.stringify(err));
                logger.logEvent();

                paymentCommon.formState('enable');
                paymentMethods.log(gateway, 'google-pay', 'Error parsing Google Pay response (catch)', err);
            });
        }).catch(function(err) {
            // check if err is not empty object
            logger.setEventResult(false);
            logger.setEventDescription('Error parsing loadPaymentData (catch): ' + JSON.stringify(err));
            logger.logEvent();

            if (JSON.stringify(err) !== '{}') {
                if (typeof err === 'object' && err.statusCode === 'CANCELED') {
                    paymentCommon.formState('enable');
                } else {
                    paymentCommon.formState('enable', {'error': _d.t.paymentProblem});
                }
            }
        });
    },
    getUnifiedGooglePayClient: function(environment, gateway, gatewayMerchantId, googleMerchantId, paymentDataRequest) {
        const baseRequest = {
            apiVersion: 2,
            apiVersionMinor: 0
        };

        if (environment === 'PRODUCTION') {
            baseRequest.googleMerchantId = googleMerchantId;
        }

        const tokenizationSpecification = {
            type: 'PAYMENT_GATEWAY',
            parameters: {
                'gateway': gateway,
                'gatewayMerchantId': gatewayMerchantId
            }
        };

        const allowedCardNetworks = ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'];
        const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];

        const baseCardPaymentMethod = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: allowedCardAuthMethods,
                allowedCardNetworks: allowedCardNetworks
            }
        };

        const cardPaymentMethod = Object.assign(
            {tokenizationSpecification: tokenizationSpecification},
            baseCardPaymentMethod
        );
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];

        const isReadyToPayRequest = Object.assign({}, baseRequest);
        isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];


        let client = new google.payments.api.PaymentsClient({environment: environment});
        client.parseResponse = function(paymentData, callback) {
            try {
                let paymentTokenData = paymentData.paymentMethodData.tokenizationData.token;
                callback(null, {nonce: paymentTokenData });
            } catch (e) {
                callback(e, null);
            }

        };
        return client;
    },
    getBraintreeGooglePayClient: function(paymentDataRequest) {
        var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
        cardPaymentMethod.parameters.billingAddressRequired = true;
        cardPaymentMethod.parameters.billingAddressParameters = {
            format: 'MIN',
            phoneNumberRequired: true
        };

        return BraintreeSDK.googlePaymentsClient;
    },
    avsDesktop: function() {
        var billingCountryHandler = $('#billingCountry');

        if (billingCountryHandler.is('select')) {
            billingCountryHandler.chosen({
                inherit_select_classes: true,
                no_results_text: _d.t.chosen_no_results_text,
                width: '100%'
            }).on('blur', function() {
                $(this).trigger('chosen:updated');
            }).on('change', function() {
                var countryCode = $(this).val();

                if (paymentCommon.countryCode !== countryCode) {
                    paymentCommon.countryCode = countryCode;

                    if (countryCode === 'US' || countryCode === 'CA') {
                        $('#billingState').prop('disabled', true).trigger('chosen:updated');

                        $.postJSON(_d.url.payments.getStates,
                            {
                                countryCode: countryCode
                            },
                            function(response) {
                                if (!response.error) {
                                    $('#billingState').prop('disabled', false).empty().append(response.data).trigger('chosen:updated');
                                    $('#billingData').show();
                                }
                            }
                        );
                    } else {
                        $('#billingData').hide();
                    }
                }
            });
        }

        $('#billingState').chosen({
            inherit_select_classes: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%'
        });
    },
    avsMobile: function() {
        var billingCountryHandler = $('#billingCountry');

        if (billingCountryHandler.is('select')) {
            billingCountryHandler.on('change', function() {
                var countryCode = $(this).val();

                if (paymentCommon.countryCode !== countryCode) {
                    paymentCommon.countryCode = countryCode;

                    if (countryCode === 'US' || countryCode === 'CA') {
                        $('#billingState').prop('disabled', true);

                        $.postJSON(_d.url.payments.getStates,
                            {
                                countryCode: countryCode
                            },
                            function(response) {
                                if (!response.error) {
                                    $('#billingState').prop('disabled', false).empty().append(response.data);
                                    $('#billingData').show();
                                }
                            }
                        );
                    } else {
                        $('#billingData').hide();
                    }
                }
            });
        }
    },
    getPaymentErrorLogPostData: function(form, formName) {
        let formFieldDefaults = {
            'ccNumber': 'Ok',
            'ccName': 'Ok',
            'ccCCV': 'Ok',
            'tos_agree': 'Ok',
            'tos_agree_condition': 'Ok',
            'ccExp[month]': 'Ok',
            'ccExp[year]': 'Ok',
            'billingState': 'Ok',
            'billingAddressLine1': 'Ok',
            'billingCity': 'Ok',
            'billingPostalCode': 'Ok',
            'billingCountry': 'Ok'
        };

        $(form).find('.validate-input.error').each(function() {
            formFieldDefaults[this.name] = 'Invalid';
        });

        $(form).find('.select-field.error').each(function() {
            formFieldDefaults[this.name] = 'Invalid';
        });

        return {
            eventName: 'Payment_InfoInputFieldError',
            attributes: {
                'attributePaymentMethod': formName,
                'attributeReservation': paymentCommon.domElements.number.val(),
                'attributeCreditCardNumber': formFieldDefaults['ccNumber'],
                'attributeCreditCardName': formFieldDefaults['ccName'],
                'attributeCreditCardCCV': formFieldDefaults['ccCCV'],
                'attributeTermsOfServiceAgree': formFieldDefaults['tos_agree'],
                'attributeCreditCardExpiryMonth': formFieldDefaults['ccExp[month]'],
                'attributeCreditCardExpiryYear': formFieldDefaults['ccExp[year]'],
                'attributeCreditCardBillingState': formFieldDefaults['billingState'],
                'attributeCreditCardBillingAddress': formFieldDefaults['billingAddressLine1'],
                'attributeCreditCardBillingCity': formFieldDefaults['billingCity'],
                'attributeCreditCardBillingPostalCode': formFieldDefaults['billingPostalCode'],
                'attributeCreditCardBillingCountry': formFieldDefaults['billingCountry'],
                'attributeModification': paymentCommon.isModification
            }
        };
    },
    sendPayNowTapEvent: function(that) {
        let postData = {
            eventName: 'Pay_Now_Tap',
            attributes: {
                'attributeReservationNumber': that.data('attribute-reservation'),
                'attributePaymentMethod': that.data('attribute-payment-method'),
                'attributeModification': that.data('attribute-modification')
            }
        };
        analyticEventTracker.trackEvent(postData);
    }
};

var paymentMethods = {
    init: function() {
        if (paymentCommon.domElements.number.length > 0 && paymentCommon.domElements.email.length > 0) {
            $.postJSON(_d.url.payments.cfjs,
                {
                    reservationNumber: paymentCommon.domElements.number.val(),
                    email: paymentCommon.domElements.email.val()
                },
                function(response) {
                    if (!response.error) {
                        paymentCommon.transactionOrderId = response.data.transactionOrderId;

                        BraintreeSDK.environment = response.data.environment;
                        BraintreeSDK.token = response.data.token;
                        BraintreeSDK.googleMerchantId = response.data.googleMerchantId;

                        BraintreeSDK.init();
                    }

                    setTimeout(function() {
                        paymentCommon.formContentPlaceholder(false);
                    }, 400);
                }
            );
        }
    },
    register: function(method) {
        var url = (method === 'google-pay' ? _d.url.payments.registerGP : _d.url.payments.registerAP),
            request = {
                number: paymentCommon.domElements.number.val(),
                email: paymentCommon.domElements.email.val(),
                transactionOrderId: paymentCommon.transactionOrderId
            };

        return $.post(url, request);
    },
    hold: function(method, requestData) {
        var url = '',
            paymentMethodString = '';

        switch (method) {
            case 'apple-pay':
                url = _d.url.payments.payByAP;
                paymentMethodString = 'Apple Pay';
                paymentCommon.formState('disable');
                break;
            case 'google-pay':
            default:
                url = _d.url.payments.payByGP;
                paymentMethodString = 'Google Pay';
        }

        $.post(url, requestData, function(response) {
            if (!response.error) {
                myDataLayer.send('payment', {'paymentMethod': paymentMethodString});

                if (Object.prototype.hasOwnProperty.call(response, 'paramsFor3dSecureChallenge') && Object.prototype.hasOwnProperty.call(response.paramsFor3dSecureChallenge, 'url')) {
                    window.location = response.paramsFor3dSecureChallenge.url;
                } else {
                    window.location = _d.url.reservation.confirmation
                        .replace('number', response.data.reservation_number)
                        .replace('email', btoa(response.data.driver_email));
                }
            } else {
                paymentCommon.formState('enable', {'error': response.message});
            }
        }, 'json').fail(function() {
            paymentCommon.formState('enable', {'error': 'Internal Server Error (5001)'});
        });
    },
    log: function(paymentGateway, paymentType, subject, msg) {
        var request = {
            number: paymentCommon.domElements.number.val(),
            email: paymentCommon.domElements.email.val(),
            transactionOrderId: paymentCommon.transactionOrderId,
            paymentGateway: paymentGateway,
            paymentType: paymentType,
            error: subject + ' (' + paymentGateway + '::' + paymentType + '): ' + JSON.stringify(msg)
        };
        $.post(_d.url.payments.clientErrorLog, request);
    }
};

var BraintreeSDK = {
    environment: '',
    token: '',
    googleMerchantId: '',
    googlePayButton: $('#google-pay-button'),
    googlePayTab: $('.payments-methods-option.google-pay'),
    applePayButton: $('#apple-pay-button'),
    applePayTab: $('.payments-methods-option.apple-pay'),
    deviceData: '',
    googlePayInstance: false,
    googlePaymentsClient: false,
    applePayInstance: false,
    init: function() {

        braintree.client.create({
            authorization: BraintreeSDK.token
        }, function(clientErr, clientInstance) {
            if (clientErr) {
                paymentMethods.log('braintree', 'general', 'Error creating client', clientErr);
            }

            braintree.dataCollector.create({
                client: clientInstance
            }, function(err, dataCollectorInstance) {
                if (err) {
                    paymentMethods.log('braintree', 'general', 'Error creating dataCollector', err);
                    return;
                }
                BraintreeSDK.deviceData = dataCollectorInstance.deviceData;
            });

            // GOOGLE PAY
            if (typeof google !== 'undefined') {
                BraintreeSDK.googlePaymentsClient = new google.payments.api.PaymentsClient({
                    environment: BraintreeSDK.environment
                });

                braintree.googlePayment.create({
                    client: clientInstance,
                    googlePayVersion: 2,
                    googleMerchantId: BraintreeSDK.googleMerchantId // Optional in sandbox; if set in sandbox, this value must be a valid production Google Merchant ID
                }, function(googlePaymentErr, googlePaymentInstance) {

                    if (googlePaymentErr) {
                        paymentMethods.log('braintree', 'google-pay', 'Error creating googlePaymentInstance', googlePaymentErr);
                    }

                    BraintreeSDK.googlePayInstance = googlePaymentInstance;

                    var allowedPaymentMethods = googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods;
                    for (var payKey in allowedPaymentMethods) {
                        if (allowedPaymentMethods[payKey]
                            && Object.prototype.hasOwnProperty.call(allowedPaymentMethods[payKey], 'parameters')
                            && Object.prototype.hasOwnProperty.call(allowedPaymentMethods[payKey].parameters, 'allowedAuthMethods')) {
                            allowedPaymentMethods[payKey].parameters.allowedAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
                        }
                    }
                    paymentMethods.log('braintree', 'google-pay', 'Payment-methods', JSON.stringify(allowedPaymentMethods));

                    BraintreeSDK.googlePaymentsClient.isReadyToPay({
                        // see https://developers.google.com/pay/api/web/reference/object#IsReadyToPayRequest
                        apiVersion: 2,
                        apiVersionMinor: 0,
                        allowedPaymentMethods: allowedPaymentMethods,
                        existingPaymentMethodRequired: true // Optional
                    }).then(function(response) {
                        if (response.result) {
                            BraintreeSDK.googlePayTab.removeClass('hidden');
                        }
                    }).catch(function(err) {
                        paymentMethods.log('braintree', 'google-pay', 'Error showing Google Pay button', err);
                        BraintreeSDK.googlePayButton.remove();
                    });
                });
            }

            //APPLE PAY
            if (window.ApplePaySession && ApplePaySession.supportsVersion(3) && ApplePaySession.canMakePayments()) {
                braintree.applePay.create({
                    client: clientInstance
                }, function(applePayErr, applePayInstance) {
                    if (applePayErr) {
                        paymentMethods.log('braintree', 'apple-pay', 'Error creating applePayInstance', applePayErr);
                    } else {
                        BraintreeSDK.applePayInstance = applePayInstance;
                        BraintreeSDK.applePayTab.removeClass('hidden');
                    }
                });
            }
        });
    }
};

var BrainTreeObj = {
    hf: null,
    threeDS: null,
    setupComponents: function(clientToken) {

        return Promise.all([
            braintree.hostedFields.create({
                authorization: clientToken,

                fields: {
                    number: {
                        selector: '#hf-number',
                        prefill: $('#ccNumber').val()
                    },
                    cvv: {
                        selector: '#hf-cvv',
                        prefill: $('#ccCCV').val()
                    },
                    expirationMonth: {
                        container: '#hf-month',
                        prefill: $('#ccExpMonth').val()
                    },
                    expirationYear: {
                        container: '#hf-year',
                        prefill: $('#ccExpYear').val()
                    }
                }

            }),
            braintree.threeDSecure.create({
                authorization: clientToken,
                version: 2
            })
        ]);
    },
    pay: function(clientData) {

        clientData.billingAddress.givenName    = $('#ccName').val();
        clientData.billingAddress.surname      = '';

        this.hf.tokenize().then(function(payload) {
            return BrainTreeObj.threeDS.verifyCard({
                onLookupComplete: function(data, next) {
                    next();
                },
                ccName: $('#ccName').val(),
                amount: clientData.amount,
                nonce: payload.nonce,
                bin: payload.details.bin,
                email: clientData.email,
                billingAddress: clientData.billingAddress
            });
        }).then(function(payload) {

            if (!payload.liabilityShifted) {
                //TODO
                logger.setEventName('Credit card');
                logger.setEventResult(false);
                logger.setEventDescription('Error: ' + _d.t._3DAuthFailed);
                logger.setEventAdditionalData('liabilityShifted: ' + payload.liabilityShifted + ', liabilityShiftPossible: ' + payload.liabilityShiftPossible);
                logger.logEvent();

                paymentCommon.formState('enable', {'error': _d.t._3DAuthFailed});
                _d.jsWarning('Problem with 3d secure. liabilityShiftPossible:' + payload.liabilityShiftPossible);

                $.postJSON(_d.url.payments.logBraintree3dsError, {
                    reservationNumber: logger.reservationNumber,
                    transactionOrderId: logger.transactionOrderId,
                    liabilityShifted: payload.liabilityShifted,
                    liabilityShiftPossible: payload.liabilityShiftPossible
                });

                return;
            }

            paymentCommon.callBackBrainTree(
                {
                    'nonce': payload.nonce,
                    'transactionOrderId': clientData.transactionOrderId,
                    'reservationNumber': clientData.reservationNumber,
                    'email': clientData.email,
                    'billingData': clientData.billingAddress
                }
            );
        }).catch(function(err) {
            logger.setEventName('Credit card');
            logger.setEventResult(false);
            logger.setEventDescription('Try catch on 3d secure: ' + JSON.stringify(err));
            logger.logEvent();

            // _d.jsError(err);
            // console.log(err);
            // console.log(payload);
            paymentCommon.formState('enable', {'error': _d.t.paymentProblem});

            var addInfo = '';
            var cLen = $('#ccNumber').val();
            cLen = cLen.length;

            addInfo +='Clen' + cLen;

            var cCV = $('#ccCCV').val();
            cCV = cCV.length;
            addInfo +='; cCV' + cCV;


            var cMonth = $('#ccExpMonth').val();
            cMonth = cMonth.length;
            addInfo +='; cMonth' + cMonth;

            var cYear= $('#ccExpYear').val();
            cYear = cYear.length;
            addInfo +='; cYear' + cYear;


            _d.jsWarning('Try catch on 3d secure: ' + err.message + ';' + addInfo);
        });
    },
    createFields: function() {
        var fields = '' +
            '<div id="hf-number"></div>' +
            '<div id="hf-month"></div>' +
            '<div id="hf-year"></div>' +
            '<div id="hf-cvv"></div>';

        $('#braintree-hosted-fields').html(fields);
    }
};
